module.exports = __webpack_public_path__ + "static/media/YF53_0.a4df608f.jpg";